import { store } from '../store'

// Resolves once Firebase has restored the persisted session (i.e. the first
// onAuthStateChanged event has fired). Router guards await this before making
// an authentication decision, otherwise a hard refresh on a protected deep link
// evaluates the guard while `user` is still null and wrongly redirects the
// authenticated user to /signin.
export default function waitForAuthReady () {
  if (store.getters.authReady) {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    const unwatch = store.watch(
      (state, getters) => getters.authReady,
      (ready) => {
        if (ready) {
          unwatch()
          resolve()
        }
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/router/wait-for-auth.js